module.exports = __webpack_public_path__ + "img/10.d10d4472.jpg";